import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "media-highlight-text-content" }
const _hoisted_2 = { class: "media-highlight-text-content__tagline h3-light" }
const _hoisted_3 = { class: "media-highlight-text-content__title h1-bold" }
const _hoisted_4 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaHighlightTextContent',
  props: {
  tagline: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

// eslint-disable-next-line no-undef


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.tagline), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.title), 1),
    _createElementVNode("div", {
      class: "media-highlight-text-content__text paragraph-light",
      innerHTML: props.text
    }, null, 8, _hoisted_4)
  ]))
}
}

})